// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"e8eeacd6","86":"c09054e2"}[chunkId] + ".chunk.js";
};